import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], totalCount:0 , error: "", message: "" }


export const publisherUserAction = createAsyncThunk(
    'publisher-user-detail',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/publiser-all-user?start_date=${data?.startDate}&end_date=${data?.endDate}&publisher_id=${data?.publisher_id}&userId=${data?.userId}&page=${data?.page}&limit=${data?.limit}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const publisherUserSlice = createSlice({
    name: 'publisher-user-detail',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(publisherUserAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(publisherUserAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.totalCount = action?.payload?.totalCount
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(publisherUserAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.totalCount = action?.payload?.totalCount

            })
        },

})



export const publisherUserReducer = publisherUserSlice.reducer